module.exports = __webpack_public_path__ + "static/media/peer.c14279f8.svg";